import React from 'react';
import { Box } from '@mui/material';
import { Ellipse1Icon, OperationsTwoIcon } from '../../../assets/icons/icons';

const OperationsIcon: React.FC = () => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
      <Ellipse1Icon 
        style={{ 
          height: '54px',
          width: '54px',
          display: 'block' 
        }}
      />
      <OperationsTwoIcon 
        style={{ 
          height: '40px',
          width: '39px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      />
    </Box>
  );
};

export default OperationsIcon;